module.exports = __webpack_public_path__ + "static/media/axle-8.98635e03.svg";